const WHATSAPP_URL = 'https://wa.me/5511913278081?text=Ol%C3%A1%2C%20preciso%20de%20atendimento%20jur%C3%ADdico%20urgente.';

const principios = [
  {
    icon: 'ri-scales-3-line',
    titulo: 'Rigor Técnico',
    descricao: 'Cada caso é analisado com profundidade e precisão jurídica. Levantamos todos os aspectos relevantes para construir estratégias sólidas, fundamentadas no conhecimento do direito e na experiência prática.',
  },
  {
    icon: 'ri-user-heart-line',
    titulo: 'Cuidado Humano',
    descricao: 'Além da técnica, compreendemos o impacto humano de cada situação jurídica. Tratamos cada cliente com empatia, transparência e respeito absoluto, porque por trás de cada caso há uma pessoa ou empresa com necessidades reais.',
  },
  {
    icon: 'ri-shield-check-line',
    titulo: 'Comprometimento',
    descricao: 'Assumimos o compromisso pleno com o resultado de cada caso. Do primeiro contato ao desfecho final, estamos presentes, dedicados e orientados para a melhor solução possível para o nosso cliente.',
  },
];

export default function Principios() {
  return (
    <section id="principios" className="py-[60px] bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-6">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="h-px w-12 bg-[#B39B62]"></span>
            <span className="text-[#B39B62] text-xs font-sans font-semibold tracking-[0.2em] uppercase">
              Nossa base
            </span>
            <span className="h-px w-12 bg-[#B39B62]"></span>
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl text-[#0A1829] font-light mb-4">
            Princípios que <span className="italic text-[#B39B62]">nos guiam</span>
          </h2>
          <p className="font-sans text-[#0A1829]/60 text-base max-w-xl mx-auto leading-relaxed">
            Os valores que fundamentam cada decisão, cada estratégia e cada relacionamento com nossos clientes.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-6">
          {principios.map((item, index) => (
            <div
              key={item.titulo}
              className="relative border-t-2 border-[#B39B62] pt-8 hover:-translate-y-1 transition-transform duration-300"
            >
              {/* Number */}
              <span className="font-serif text-6xl text-[#E9D59C] font-light leading-none absolute top-4 right-0 select-none">
                {String(index + 1).padStart(2, '0')}
              </span>

              <div className="w-10 h-10 flex items-center justify-center mb-5">
                <i className={`${item.icon} text-[#B39B62] text-2xl`}></i>
              </div>
              <h3 className="font-serif text-xl text-[#0A1829] font-medium mb-4">{item.titulo}</h3>
              <p className="font-sans text-[#0A1829]/60 text-sm leading-relaxed">{item.descricao}</p>
            </div>
          ))}
        </div>

        {/* WhatsApp CTA */}
        <div className="text-center">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#B39B62] hover:bg-[#E9D59C] text-[#0A1829] font-sans font-semibold text-sm px-8 py-4 rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-base"></i>
            Entre em contato agora
          </a>
        </div>
      </div>
    </section>
  );
}
